import * as tslib_1 from "tslib";
import { lazyRegisterServiceworker } from 'owa-serviceworker-cache';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { getBrowserInfo, isMinimumBrowserVersion } from 'owa-user-agent';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { isFrameworkFeatureEnabled } from 'owa-feature-flags';
export default function initializeServiceWorker(windowObj, appName) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var serviceWorkerContainer, userConfiguration;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    serviceWorkerContainer = windowObj.navigator != null && windowObj.navigator.serviceWorker;
                    if (!(serviceWorkerContainer != null &&
                        browserSupported() &&
                        !isFrameworkFeatureEnabled('fwk-prefetch-code-off'))) return [3 /*break*/, 2];
                    userConfiguration = getUserConfiguration();
                    return [4 /*yield*/, lazyRegisterServiceworker.importAndExecute(windowObj, appName, userConfiguration.SessionSettings.UserLanguage, userConfiguration.UserOptions.IsDarkModeTheme)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    if (serviceWorkerContainer != null && serviceWorkerContainer.controller != null) {
                        serviceWorkerContainer
                            .getRegistrations()
                            .then(function (registrations) {
                            for (var i = 0; i < registrations.length; ++i) {
                                registrations[i].unregister();
                            }
                        });
                    }
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
function browserSupported() {
    var browserInfo = getBrowserInfo();
    return (browserInfo.browser == "Chrome" /* CHROME */ ||
        browserInfo.browser == "Firefox" /* FIREFOX */ ||
        (isMailFeatureEnabled('auth-ServiceWorkerEdge') &&
            browserInfo.browser == "Edge" /* EDGE */ &&
            isMinimumBrowserVersion([17, 17134])) ||
        (isMailFeatureEnabled('auth-ServiceWorkerSafari') &&
            browserInfo.browser == "Safari" /* SAFARI */ &&
            isMinimumBrowserVersion([11, 1])));
}
//# sourceMappingURL=initializeServiceWorker.js.map